type DeliveryZoneArchiveAction = 'archive' | 'restore';

type ConfirmDialogContent = {
  title: string;
  description: (deliveryZoneName: string) => string;
  confirmLabel: string;
};

export const DELIVERY_ZONE_CONFIRM_DIALOG_CONTENT: Record<DeliveryZoneArchiveAction, ConfirmDialogContent> = {
  archive: {
    title: 'Archiver la zone de livraison',
    description: (deliveryZoneName) =>
      `La zone « ${deliveryZoneName} » ne sera plus proposée aux villes de livraison, et pourra être restaurée.`,
    confirmLabel: 'Archiver',
  },
  restore: {
    title: 'Restaurer la zone de livraison',
    description: (deliveryZoneName) =>
      `La zone « ${deliveryZoneName} » sera de nouveau proposée aux villes de livraison.`,
    confirmLabel: 'Restaurer',
  },
};
